import { MessageService } from 'primeng/api';

const DETALLE_POR_DEFECTO =
  'El cumplimiento fue registrado, pero no se pudo guardar toda la informacion adicional.';

/**
 * Avisa al usuario cuando el cumplimiento quedó registrado pero falló la información adicional
 * (observaciones, recomendaciones o contactos adicionales).
 * Legacy (CreateOrUpdateCumplimientoActivity): el fallo de los contactos se añade al mensaje del
 * guardado; nunca pasa en silencio.
 */
export function avisarPostPersistencia(
  messageService: MessageService,
  response: { warningPostPersistencia?: boolean; mensajeWarningPostPersistencia?: string | null } | null | undefined
): void {
  if (!response?.warningPostPersistencia) {
    return;
  }
  messageService.add({
    severity: 'warn',
    summary: 'Informacion complementaria pendiente',
    detail: response.mensajeWarningPostPersistencia?.trim() || DETALLE_POR_DEFECTO,
    life: 8000
  });
}
